import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const GO_LEVELS = [
  { label: "GO", text: "Interessante Firma entdeckt, noch mit niemandem gesprochen." },
  { label: "GO!", text: "Mit einer Person gesprochen, die nicht weiterhelfen kann; kein relevanter Ansprechpartner." },
  { label: "GO!!", text: "Kontakt kennt den Chef und kann über eine Registrierung sowie einen Betrag von mindestens 5 € entscheiden." },
  { label: "GO!!!", text: "Entscheider gesprochen, der über finanzielle Ausgaben und die Zusammenarbeit entscheiden kann." },
  { label: "GO!!!!", text: "CEO oder Geschäftsführer ist begeistert und möchte Dr. Hoffmann aktiv weiterempfehlen." },
];

const GoMessagesGuide = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <button
        type="button"
        className="employee-go-entry"
        aria-haspopup="dialog"
        aria-labelledby="employee-go-trigger-label"
        aria-describedby="employee-go-read-badge"
        onClick={() => setOpen(true)}
      >
        <span id="employee-go-read-badge" className="employee-go-read-badge">Bitte lesen!</span>
        <span id="employee-go-trigger-label" className="employee-go-trigger">
          <ChatBubbleOutlineIcon fontSize="small" aria-hidden="true" />
          GO Nachrichten
        </span>
      </button>

      <Dialog
        open={open}
        onClose={close}
        fullWidth
        maxWidth="sm"
        scroll="paper"
        disableScrollLock={false}
        className="employee-go-modal"
        PaperProps={{ className: "employee-go-dialog" }}
        aria-labelledby="employee-go-title"
        aria-describedby="employee-go-intro"
      >
        <DialogTitle id="employee-go-title" className="employee-go-title">
          <span>GO Nachrichten</span>
          <IconButton onClick={close} aria-label="Leitfaden schließen">
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className="employee-go-content">
          <p className="employee-go-kicker">Kurzleitfaden · Hoffi über WhatsApp</p>
          <p id="employee-go-intro">
            Hoffi ist unser KI-Agent für die tägliche Vertriebsarbeit. Schicke deine
            Besuchsberichte in die WhatsApp-Gruppe <strong>„Vertriebsteam MediConsult“</strong>,
            damit Informationen und Umsätze korrekt zugeordnet werden können.
          </p>

          <section className="employee-go-section">
            <h3>Jeden Firmenbesuch dokumentieren</h3>
            <p>Direkt nach jedem einzelnen Besuch eine kurze Nachricht senden – auch wenn du niemanden angetroffen hast. Jede GO-Nachricht zählt als ein Firmenbesuch für dein Zusatzziel.</p>
          </section>

          <section className="employee-go-section">
            <h3>Die fünf GO-Stufen</h3>
            <ul className="employee-go-levels">
              {GO_LEVELS.map((level) => (
                <li key={level.label}>
                  <span className="employee-go-level-label">{level.label}</span>
                  <p>{level.text}</p>
                </li>
              ))}
            </ul>
          </section>

          <section className="employee-go-section">
            <h3>Eine Nachricht pro Firma</h3>
            <p>Foto und GO-Text gemeinsam in einer einzigen WhatsApp-Nachricht senden. Verwende dieses Format:</p>
            <p className="employee-go-format">
              GO-Stufe + Kundenstatus / Firmenname / Notiz / Aufgabe (optional)
            </p>
            <div className="employee-go-example">
              <strong>Beispiel</strong>
              <p>
                GO!! Silber / Beispiel GmbH / Mit Thomas gesprochen, 79 € Umsatz,
                Termin für den 11.11.2026 gebucht / Aufgabe für Sura: Folgetermin klären
              </p>
            </div>
            <ul className="employee-go-checklist">
              <li>
                <strong>Foto:</strong> Visitenkarte mit korrekt lesbarer Adresse beifügen.
                Ohne Visitenkarte reichen handschriftlicher Firmenname und Adresse als Foto.
              </li>
              <li className="employee-go-revenue-note">
                <strong className="employee-go-revenue-label">UMSATZ:</strong> Wenn du Umsatz
                erzielt hast, schreibe immer den genauen Betrag in deine GO-Nachricht.{' '}
                <strong>Ohne Umsatzangabe kann der Betrag deinem Mitarbeiterkonto nicht gutgeschrieben werden.</strong>
              </li>
            </ul>
          </section>

          <section className="employee-go-callout">
            <h3>Manueller Termin durch Olli?</h3>
            <p>
              <strong>Olli immer direkt <a href="tel:+491797336154">anrufen</a></strong>, wenn er einen Termin für dich
              manuell eintragen soll. So kann er ihn korrekt und schnell im System erfassen.
            </p>
          </section>
        </DialogContent>

        <DialogActions className="employee-go-actions">
          <button type="button" className="employee-go-close" onClick={close}>
            Schließen
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GoMessagesGuide;
